var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "d-flex justify-content-center px-4",
      attrs: { id: "list-details-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
        },
      },
    },
    [
      _c("list-details", {
        attrs: {
          list: _vm.currentList,
          creating: _vm.creating,
          "import-contacts": _vm.importContacts,
          visibility: _vm.fieldsVisibility,
        },
        on: { change: _vm.handleChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }